import React, { useState } from 'react';

import { PrevFileFrameLoader } from './PrevFileFrameLoader';

interface IFrameProps {
    iframeSrc: string;
    decodeURL: string;
}

export const PrevFileFrame = ({ iframeSrc, decodeURL }: IFrameProps) => {
    const [loading, setLoading] = useState(true);

    const handleLoad = () => {
        setLoading(false);
    };

    return (
        <>
            {loading && <PrevFileFrameLoader />}
            <iframe
                title={`${iframeSrc}${decodeURL}`}
                src={`${iframeSrc || ''}${decodeURL}`}
                width="720"
                height={window.innerHeight - 132}
                style={{ border: 'none' }}
                onLoad={handleLoad}
                onError={() => console.log('error')}
            />
        </>
    );
};
